import {
  InviteUser,
  InvitationSuccess,
  Register,
  EmailVerified,
  EmailSent,
} from '~/pages/Auth';
import { Track } from '~/pages/Track';
import Privacy from '~/pages/Privacy/Privacy';
import { UnifiedNewPassword } from '~/pages/UnifiedAuth/UnifiedNewPassword';
import GetApp from '~/pages/GetApp/GetApp';

export const publicRoutes = [
  {
    path: 't/:code',
    element: <Track />,
  },
  {
    path: 'register/verified',
    element: <EmailVerified />,
  },
  {
    path: 'register/sent',
    element: <EmailSent />,
  },
  {
    path: 'invite-user',
    element: <InviteUser />,
  },
  {
    path: 'invite-user/success',
    element: <InvitationSuccess />,
  },
  {
    path: 'new-password',
    element: <UnifiedNewPassword />,
  },
  {
    path: 'register',
    element: <Register />,
  },
  {
    path: 'privacy-policy',
    element: <Privacy />,
  },
  {
    path: 'getapp',
    element: <GetApp />,
  },
];
